import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	routes: [
		// 默认路由
		{
			path: "/",
			redirect: "main"
		},
		// 首页路由
		{
			path: '/main',
			name: 'main',
			component: () => import('./views/main'),
			meta: {
				title: 'main',
				keepAlive: true
			},
		},
		// 登录
		{
			path: "/login",
			name: "login",
			component: () => import("./views/login.vue"),
			meta: {
				title: 'login',
				keepAlive: true
			},
		},
		{
			path: "/forget",
			component: () => import('./views/forget')
		},
		// 注册
		{
			path: "/register",
			name: "register",
			component: () => import("./views/register"),
			meta: {
				title: 'register',
				keepAlive: true
			},
		},
		// 商品列表
		{
			path: "/plist/:priority?",
			name: "plist",
			component: () => import("./views/plist"),
			meta: {
				title: 'plist',
				keepAlive: true,
				updateScroll: true
			},
		},
		// 商品详情
		{
			path: "/pdetail",
			name: "pdetail",
			component: () => import("./views/pdetail"),
			props: true,
			meta: {
				title: 'pdetail',
				keepAlive: true
			},
		},
		// 个人中心
		{
			path: "/center",
			component: () => import("./views/center"),
			children: [
				// 默认路由
				{
					path: "",
					redirect: { name: "centerMain" },
				},
				// 首页管理
				{
					path: "main",
					name: "centerMain",
					component: () => import("./views/centerMain")
				},
				// 我的商品
				{
					path: "goods",
					name: "goods",
					component: () => import("./views/centerGoods")
				},
				// 管理子公司/分行
				{
					path: "branch",
					name: "branch",
					component: () => import("./views/centerBranch")
				},
				// 收货地址管理
				{
					path: "address",
					name: "address",
					component: () => import("./views/centerAddress")
				},
				// 管理部门
				{
					path: "department",
					name: "department",
					component: () => import("./views/centerDepartment")
				},
				// 管理用户
				{
					path: "member",
					name: "member",
					component: () => import("./views/centerMember")
				},
				// 资料修改
				{
					path: "data",
					name: "data",
					component: () => import("./views/centerData")
				},
				// 用户密码修改
				{
					path: "pwd",
					name: "pwd",
					component: () => import("./views/centerPwd")
				},
				// 支援中心
				{
					path: "callcenter",
					name: "callcenter",
					component: () => import("./views/centerCallcenter")
				},
				// 报价车
				{
					path: "quoteCart",
					name: "quoteCart",
					component: () => import("./views/centerQuoteCart")
				},
				// 报价车订单
				{
					path: "quoteOrder",
					name: "quoteOrder",
					component: () => import("./views/centerQuoteOrder")
				},
				// 购物车
				{
					path: "cart",
					name: "cart",
					component: () => import("./views/centerCart")
				},
				// 订单状态
				{
					path: "orderStatus",
					name: "orderStatus",
					component: () => import("./views/centerOrderStatus")
				},
				// 订单支付状态
				{
					path: "payStatus",
					name: "payStatus",
					component: () => import("./views/centerPay")
				},
				// 订单管理
				{
					path: "order",
					name: "order",
					component: () => import("./views/centerOrder")
				},
				// 数据分析
				{
					path: "analysis",
					name: "analysis",
					component: () => import("./views/centerAnalysis"),
				},
				// 月结单下载
				{
					path: "statement",
					name: "statement",
					component: () => import("./views/centerStatement")
				},
				// 我的收藏
				{
					path: "collection",
					name: "collection",
					component: () => import("./views/centerCollection")
				},
			]
		},
		// 购物车订单
		{
			path: '/cartOrder',
			name: 'cartOrder',
			component: () => import('./views/cartOrder'),
			meta: {
				title: 'cartOrder',
				keepAlive: true
			},
		},
		// 产品试用说明列表页
		{
			path: "/instructions",
			name: "instrlist",
			component: () => import('./views/instrList')
		},
		// 产品试用说明详情页
		{
			path: "/instructionsDetail",
			name: "instrdetail",
			component: () => import('./views/instrDetail')
		},
		// 关于我们
		{
			path: "/about",
			name: "about",
			component: () => import("./views/other")
		},
		// 企业文化
		{
			path: "/culture",
			name: "culture",
			component: () => import("./views/other")
		},
		// 最新消息
		{
			path: "/news",
			name: "news",
			component: () => import("./views/other")
		},
		// 联系我们
		{
			path: "/contact",
			name: "contact",
			component: () => import("./views/other")
		},
		// 其它服务
		{
			path: "/service",
			component: () => import("./views/service"),
			children: [
				// 默认路由
				{
					path: "",
					redirect: { name: "repair" },
				},
				// 维修服务
				{
					path: "repair",
					name: "repair",
					component: () => import("./views/serviceRepair")
				},
				// 文件货物寄存
				{
					path: "deposit",
					name: "deposit",
					component: () => import("./views/serviceDeposit")
				},
				// 文件货物代送
				{
					path: "delivery",
					name: "delivery",
					component: () => import("./views/serviceDelivery")
				},
			]
		},
		// 帮助中心
		{
			path: "/help",
			name: "help",
			component: () => import("./views/other")
		},
		// 服务支持
		{
			path: "/serve",
			name: "serve",
			component: () => import("./views/other")
		},
		// 线下门店
		{
			path: "/store",
			name: "store",
			component: () => import("./views/other")
		},
		// 店铺加盟
		{
			path: "/join",
			name: "join",
			component: () => import("./views/other")
		},
	],
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			if (from.meta.keepAlive) {
				from.meta.savedPosition = document.body.scrollTop
			}
			return { x: 0, y: to.meta.savedPosition || 0 }
		}
	}
})
